import React, { useContext, useEffect, useState } from "react";
import { Tab } from "bootstrap";
import { Download, Edit, ModeEdit, UploadFile } from "@mui/icons-material";
import Cookies from "js-cookie";
import { UserContext } from "./SharedData/UserProvider";
import { jwtDecode } from "jwt-decode";

import "../../src/pages/MyCss/profile.css";
import UploadFileInput from "./Inputs/UploadFileInput";
import { FaExclamationTriangle, FaEye } from "react-icons/fa";
import { checkAge } from "./SharedData/utils";
import { ApiUrl, FileLinkImg } from "../config";

const ProfilePatient = () => {
  useEffect(() => {
    const tabElements = document.querySelectorAll("#profileTabs a");
    tabElements.forEach((tab) => {
      new Tab(tab);
    });
  }, []);

  const [citoyenInfo, setCitoyenInfo] = useState([]);
  const token = Cookies.get("access_token");
  const [NewcitoyenInfo, setNewCitoyenInfo] = useState(citoyenInfo);
  const [successMessage, setSuccessMessage] = useState("");
  const [ErrorMessage, setErrorMessage] = useState("");

  const GetCitoyenById = async (page) => {
    if (token) {
      const decodedToken = jwtDecode(token);
      const citoyen_id = decodedToken.citoyen_id;
      try {
        const response = await fetch(
          `${ApiUrl}citoyen-by-id?citoyen_id=${citoyen_id}`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          }
        );

        if (!response.ok) {
          throw new Error("Failed to fetch data");
        }

        const data = await response.json();
        setCitoyenInfo(data.citoyen);
        setNewCitoyenInfo(data.citoyen);
        // Check if profile is incomplete
        const isProfileIncomplete =
          !data.citoyen.nom ||
          !data.citoyen.prenom ||
          !data.citoyen.cin ||
          !data.citoyen.cinRecto ||
          !data.citoyen.cinVerso ||
          !data.citoyen.adresse;

        // Set profile incomplete state (e.g., IncompleteProfile) based on the condition
        setIncompleteProfile(isProfileIncomplete);
        console.log(data);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    }
  };

  const [isEditing, setIsEditing] = useState(false);

  const handleEditClick = () => {
    setIsEditing(true);
  };

  useEffect(() => {
    GetCitoyenById();
  }, [token]);

  const validateForm = () => {
    if (!NewcitoyenInfo.nom) {
      return "Le nom est obligatoire !";
    }
    if (!NewcitoyenInfo.prenom) {
      return "Le prénom est obligatoire !";
    }
    if (!NewcitoyenInfo.date_naissance) {
      return "La date de naissance est obligatoiree !";
    }
    if (!NewcitoyenInfo.cin) {
      return "Le CIN est obligatoire !";
    }
    if (!NewcitoyenInfo.adresse) {
      return "L'adresse est obligatoiree !";
    }

    if (NewcitoyenInfo.date_naissance) {
      if (!checkAge(NewcitoyenInfo.date_naissance)) {
        return "Vous devez avoir au moins 18 ans !";
      }
    }

    return "";
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const ValidateFormSuccess = validateForm();

    setErrorMessage("");

    if (ValidateFormSuccess) {
      console.log(ValidateFormSuccess);
      setErrorMessage(ValidateFormSuccess);
      return;
    }

    const formData = {
      prenom: NewcitoyenInfo.prenom,
      nom: NewcitoyenInfo.nom,
      date_naissance: NewcitoyenInfo.date_naissance,
      cin: NewcitoyenInfo.cin,
      adresse: NewcitoyenInfo.adresse,
    };

    try {
      const response = await fetch(`${ApiUrl}update-citoyen-info`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`, // Include token if using authentication
        },
        body: JSON.stringify(formData),
      });

      const data = await response.json();
      if (response.ok) {
        setIsEditing(false);
        setSuccessMessage(
          "Les informations ont été mises à jour avec succès !"
        );
        setTimeout(() => setSuccessMessage(""), 3000);
      } else {
        console.error("Error updating citoyen:", data.message);
        setErrorMessage(
          `Erreur : ${data.message || "Détails non disponibles"}`
        );
        //setTimeout(() => this.setErrorMessage(""), 5000);
      }
    } catch (error) {
      console.error("Network error:", error);
    }
  };

  const setUpdateCitoyenInfo = (field, value) => {
    setNewCitoyenInfo((prevState) => ({
      ...prevState,
      [field]: value, // Dynamically update the field in citoyenInfo
    }));
  };

  const handleCancel = () => {
    setErrorMessage("");
    setNewCitoyenInfo(citoyenInfo);
    setIsEditing(false);
  };

  const [IncompleteProfile, setIncompleteProfile] = useState(false);

  return (
    <div>
      <nav aria-label="breadcrumb">
        <ol className="breadcrumb breadcrumb-no-gutter">
          <li className="breadcrumb-item">
            <a className="breadcrumb-link" href="#">
              Page d'accueil
            </a>
          </li>
          <li
            className="breadcrumb-item active"
            style={{ color: "rgb(255, 77, 7)" }}
            aria-current="page"
          >
            Profile
          </li>
        </ol>
      </nav>

      <div className="row justify-content-lg-center">
        <div
          className="col-lg-7"
          data-aos="fade-out"
          data-aos-delay="100"
          data-aos-duration="900"
        >
          <div className="card">
            {/* Profile Header */}
            <div className="profile-cover" style={{ position: "relative" }}>
              <div
                className="profile-cover-img-wrapper"
                style={{ position: "relative" }}
              >
                <img
                  className="profile-cover-img"
                  src="https://htmlstream.com/preview/front-dashboard-v2.1.1/assets/img/1920x400/img1.jpg"
                  alt="Profile Cover"
                />
              </div>
              <div className="text-center mb-5">
                <div className="profile-avatar avatar-xxl avatar-circle profile-cover-avatar">
                  <img
                    className="avatar-img"
                    src={`/assets/img/hna-meak/women-removebg-preview.png`}
                    alt="Profile Avatar"
                  />
                </div>
              </div>
            </div>

            <div class="card-header mt-2 d-flex justify-content-between">
              <div className="d-flex">
                <h4 class="card-header-title">Profile </h4>
                <>
                  {/* Conditionally render the alert if citoyenInfo exists and profile is incomplete */}
                  {citoyenInfo && IncompleteProfile && (
                    <div
                      className="alert alert-danger ms-3 custom-alert-danger d-flex align-items-center py-1 px-2 transition-all"
                      role="alert"
                      aria-live="assertive"
                    >
                      <FaExclamationTriangle
                        style={{ marginRight: "10px", fontSize: "1.2em" }}
                      />
                      <span>Profil non complété</span>
                    </div>
                  )}
                </>
              </div>
            </div>

            <div className="card-body">
              {/* Tabs */}
              <ul
                className="nav  nav-pills  d-flex mb-4 "
                id="profileTabs"
                role="tablist"
              >
                <li className="nav-item flex-fill" role="presentation">
                  <a
                    className="profile-patient nav-link  active"
                    id="info-tab"
                    data-bs-toggle="tab"
                    href="#info"
                    role="tab"
                    aria-controls="info"
                    aria-selected="true"
                  >
                    Informations
                  </a>
                </li>
                <li className="nav-item flex-fill" role="presentation">
                  <a
                    className="profile-patient nav-link"
                    id="documents-tab"
                    data-bs-toggle="tab"
                    href="#documents"
                    role="tab"
                    aria-controls="documents"
                    aria-selected="false"
                  >
                    Documents
                  </a>
                </li>
              </ul>

              {/* Tab Content */}
              <div className="tab-content mt-4" id="profileTabContent">
                {/* Informations Tab */}
                <div
                  className="tab-pane fade show active"
                  id="info"
                  role="tabpanel"
                  aria-labelledby="info-tab"
                >
                  {/* Display Success Message */}
                  {successMessage && (
                    <div className="alert alert-success" role="alert">
                      {successMessage}
                    </div>
                  )}

                  {ErrorMessage && (
                    <div
                      className="alert alert-danger custom-alert-danger"
                      role="alert"
                    >
                      {ErrorMessage}
                    </div>
                  )}

                  <form onSubmit={handleSubmit}>
                    <div className="d-flex justify-content-end mb-2">
                      <button
                        type="button"
                        className="custom-btn btn-white"
                        onClick={handleEditClick}
                      >
                        <ModeEdit
                          style={{ color: "#677788", cursor: "pointer" }}
                        />
                      </button>
                    </div>

                    <div id="accountType" class="row mb-4">
                      <label class="col-sm-3 col-form-label form-label">
                        Sexe
                      </label>

                      <div class="col-sm-9">
                        <div class="input-group input-group-sm-vertical">
                          {/* <!-- Radio Check --> */}
                          <label
                            className={"profile-group-form-control"}
                            for="userAccountTypeRadio1"
                          >
                            <span class="form-check">
                              <input
                                type="radio"
                                class="form-check-input"
                                name="userAccountTypeRadio"
                                id="userAccountTypeRadio2"
                                checked={citoyenInfo.type === "homme"}
                                disabled
                              />
                              <span class="form-check-label">Homme</span>
                            </span>
                          </label>
                          {/* <!-- End Radio Check --> */}

                          {/* <!-- Radio Check --> */}
                          <label
                            className={"profile-group-form-control"}
                            for="userAccountTypeRadio2"
                          >
                            <span class="form-check">
                              <input
                                type="radio"
                                class="form-check-input"
                                name="userAccountTypeRadio"
                                id="userAccountTypeRadio2"
                                checked={citoyenInfo.type === "femme"}
                                disabled
                              />
                              <span class="form-check-label">Femme</span>
                            </span>
                          </label>
                          {/* <!-- End Radio Check --> */}
                        </div>
                      </div>
                    </div>

                    <div className="row mb-4">
                      <div className="col-6">
                        <div className="form-group">
                          <label className="sr-only">
                            Nom <span className="text-danger  fw-bold">*</span>
                          </label>
                          <input
                            type="text"
                            className={`profile-group-form-control w-100 ${
                              isEditing ? "active-input" : ""
                            }`}
                            name="firstName"
                            id="firstNameLabel"
                            placeholder="Your first name"
                            aria-label="Your first name"
                            value={NewcitoyenInfo.nom || ""}
                            disabled={!isEditing}
                            onChange={(e) =>
                              setUpdateCitoyenInfo("nom", e.target.value)
                            }
                          />
                        </div>
                      </div>

                      <div className="col-6">
                        <div className="form-group">
                          <label className="sr-only">
                            Prénom{" "}
                            <span className="text-danger  fw-bold">*</span>
                          </label>
                          <input
                            type="text"
                            className={`profile-group-form-control w-100 ${
                              isEditing ? "active-input" : ""
                            }`}
                            name="lastName"
                            id="lastNameLabel"
                            placeholder="Your last name"
                            aria-label="Your last name"
                            value={NewcitoyenInfo.prenom || ""}
                            disabled={!isEditing}
                            onChange={(e) =>
                              setUpdateCitoyenInfo("prenom", e.target.value)
                            }
                          />
                        </div>
                      </div>
                    </div>

                    <div className="row mb-4">
                      <div className="col-6">
                        <div className="form-group">
                          <label className="sr-only">
                            Date de Naissance{" "}
                            <span className="text-danger  fw-bold">*</span>
                          </label>
                          {/* <input
                            type="text"
                            className={`profile-group-form-control w-100 ${
                              isEditing ? "active-input" : ""
                            }`}
                            name="phone"
                            id="phone"
                            placeholder="02-12-2001"
                            aria-label="phone"
                            value={NewcitoyenInfo.date_naissance || ""}
                            disabled={!isEditing}
                          /> */}

                          <input
                            type="date"
                            className={`profile-group-form-control w-100 ${
                              isEditing ? "active-input" : ""
                            }`}
                            name="dob"
                            value={NewcitoyenInfo.date_naissance || ""}
                            onChange={(e) =>
                              setUpdateCitoyenInfo(
                                "date_naissance",
                                e.target.value
                              )
                            }
                            placeholder="DD/MM/YYYY"
                            disabled={!isEditing}
                          />
                        </div>
                      </div>

                      <div className="col-6">
                        <div className="form-group">
                          <label className="sr-only">
                            CIN <span className="text-danger  fw-bold">*</span>
                          </label>
                          <input
                            type="text"
                            className={`profile-group-form-control w-100 ${
                              isEditing ? "active-input" : ""
                            }`}
                            name="cin"
                            id="cin"
                            placeholder="cin"
                            aria-label="cin"
                            value={NewcitoyenInfo.cin || ""}
                            disabled={!isEditing}
                            onChange={(e) =>
                              setUpdateCitoyenInfo("cin", e.target.value)
                            }
                          />
                        </div>
                      </div>
                    </div>

                    <div className="row mb-4">
                      <div className="col-12">
                        <div className="form-group">
                          <label className="sr-only">
                            Adresse{" "}
                            <span className="text-danger  fw-bold">*</span>
                          </label>
                          <textarea
                            className={`w-100 profile-group-form-control ${
                              isEditing ? "active-input" : ""
                            }`}
                            id="textAreaExample1"
                            rows="4"
                            value={NewcitoyenInfo.adresse || ""}
                            disabled={!isEditing}
                            onChange={(e) =>
                              setUpdateCitoyenInfo("adresse", e.target.value)
                            }
                          ></textarea>
                        </div>
                      </div>
                    </div>
                    <div className="d-flex justify-content-end  pb-2">
                      {/* Conditionally render buttons based on isEditing */}
                      {isEditing && (
                        <>
                          {/* Cancel button */}
                          <button
                            type="button"
                            className="btn btn-border-gray me-2"
                            onClick={handleCancel}
                          >
                            Annuler
                          </button>

                          {/* Save button */}
                          <button type="submit" className="btn btn-dark">
                            Enregister
                          </button>
                        </>
                      )}
                    </div>
                  </form>

                  <form className="border-top">
                    <h4 class="card-header-title mt-3 mb-4">Contact</h4>

                    <div class="row mb-4">
                      <label
                        for="emailLabel"
                        class="col-sm-3 col-form-label form-label"
                      >
                        Email
                      </label>

                      <div class="col-sm-9">
                        <input
                          type="email"
                          className={"profile-group-form-control"}
                          name="email"
                          id="emailLabel"
                          placeholder="Email"
                          aria-label="Email"
                          value={citoyenInfo.user?.email || ""}
                          disabled
                        />
                      </div>
                    </div>
                    <div class="row mb-4">
                      <label class="col-sm-3 col-form-label form-label">
                        N° Téléphone
                      </label>

                      <div className="col-sm-9">
                        <div className="input-with-label">
                          <span className="input-label">+212</span>
                          <input
                            type="text"
                            className={"profile-group-form-control"}
                            name="phone"
                            id="phone"
                            placeholder="###########"
                            value={citoyenInfo.user?.phone || ""}
                            disabled
                          />
                        </div>
                      </div>
                    </div>
                  </form>
                </div>

                {/* Documents Tab */}
                <div
                  className="tab-pane fade"
                  id="documents"
                  role="tabpanel"
                  aria-labelledby="documents-tab"
                >
                  <UploadFileInput />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProfilePatient;
